import React, { useState, useEffect } from 'react';
//import { useOrganization } from '../contexts/OrganizationContext';
//import { fetchSubscriptions } from '../services/subscriptionService';
import { Link, useNavigate } from 'react-router-dom';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SettingsIcon from '@mui/icons-material/TuneOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCardOutlined';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Select,
  InputLabel,
  Box,
  Divider,
  ListItemIcon,
  FormControl,
} from '@mui/material';

const DashboardHeader = () => {
  const topMenu = [
    //{ label: 'Dashboard', path: '/dashboard' },
    //{ label: 'Plan Mission', path: '/plan-mission' },
    //{ label: 'Documents', path: '/documents' },
    //{ label: 'Flights', path: '/flights' },
    //{ label: 'Missions Calendar', path: '/calendar' },
    //{ label: 'SolvPro', path: '/solvpro' },
  ];

  //const accountGuid = localStorage.getItem('authSession')
  //  ? JSON.parse(localStorage.getItem('authSession')).accountGuid
  //  : null;

  const navigate = useNavigate();
  //  const { selectedOrg, updateSelectedOrg } = useOrganization();
  //  const [subscriptions, setSubscriptions] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  //const [loading, setLoading] = useState(true);
  //const [error, setError] = useState(null);

  /*
  useEffect(() => {
    const loadSubscriptions = async () => {
      try {
        const data = await fetchSubscriptions(accountGuid); // Fetch subscriptions from the API
        setSubscriptions(data); // Update subscriptions state
        if (!selectedOrg && data.length > 0) {
          // Set default org if none is selected
          const defaultOrg = data[0].subscriptionGuid;
          updateSelectedOrg(defaultOrg);
          localStorage.setItem('selectedOrg', defaultOrg);
        }
      } catch (err) {
        setError('Failed to load subscriptions.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadSubscriptions();
  }, [selectedOrg]);
*/

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAccount = () => {
    handleMenuClose();
    navigate('/account');
  };

  const handleBilling = () => {
    handleMenuClose();
    navigate('/billing');
  };

  const handleSignOut = () => {
    // Clear session data from localStorage or sessionStorage
    localStorage.removeItem('authSession'); // Or sessionStorage.removeItem('authSession');

    // Optionally clear other application states if necessary
    // Example: Reset Redux state or React context

    // Close the menu and navigate to the home page
    handleMenuClose();
    navigate('/');
  };

  /*
    const handleOrgChange = (event) => {
      const orgId = event.target.value;
      updateSelectedOrg(orgId);
    };
  */

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: 1201,
        backgroundColor: '#34495e',
        color: '#ecf0f1',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img
          src="/instapath-logo.png"
          alt="Instapath Logo"
          style={{
            width: '144px',
            marginRight: '16px',
          }}
        />

        {/* Organization Dropdown */}
        {/*
        <Box
          sx={{
            display: 'none', //flex',
            alignItems: 'center',
            flexGrow: 1,
            marginLeft: '16px', // Align with LeftNav
          }}
        >
          {loading ? (
            <Typography variant="body2" sx={{ color: '#ecf0f1' }}>
              Loading organizations...
            </Typography>
          ) : error ? (
            <Typography variant="body2" sx={{ color: 'red' }}>
              {error}
            </Typography>
          ) : (
            <FormControl
              sx={{
                minWidth: 200,
                marginRight: 2,
                backgroundColor: '#2c3e50',
                borderRadius: '8px',
                height: '36px',
                '& .MuiInputBase-root': {
                  height: '36px', // Ensure dropdown matches the height
                },
              }}
            >
              <Select
                value={selectedOrg}
                onChange={handleOrgChange}
                sx={{
                  color: '#ecf0f1', // Text color
                  backgroundColor: '#2c3e50',
                  borderRadius: '8px',
                  height: '100%',
                  '& .MuiSelect-icon': { color: '#ecf0f1' }, // Icon color
                }}
              >
                {subscriptions.map((sub) => (
                  <MenuItem
                    key={sub.subscriptionGuid}
                    value={sub.subscriptionGuid}
                    sx={{
                      color: '#2c3e50', // Darker text color for items
                      '&.Mui-selected': {
                        backgroundColor: '#e0f7fa', // Subtle background for selected item
                        color: '#2c3e50', // Maintain dark text for selected
                      },
                      '&:hover': {
                        backgroundColor: '#f5f5f5', // Hover effect for items
                      },
                    }}
                  >
                    {sub.orgName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
*/}


        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
          {topMenu.map((item, index) => (
            <Button
              key={index}
              component={Link}
              to={item.path}
              sx={{
                color: '#ecf0f1',
                marginLeft: 1,
                fontWeight: 400,
                textTransform: 'none',
                '&:hover': { backgroundColor: '#2c3e50' },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
        <IconButton
          color="inherit"
          onClick={handleMenuOpen}
          aria-controls="more-menu"
          aria-haspopup="true"
        >
          <PersonOutlineIcon />
        </IconButton>
        <Menu
          id="more-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={{
            '& .MuiPaper-root': {
              backgroundColor: '#ffffff', // Menu background color
              color: '#2c3e50', // Text color
            },
          }}
        >
          <MenuItem onClick={handleAccount}>
            {/*<ListItemIcon>
              <SettingsIcon sx={{ color: '#2c3e50' }} />
            </ListItemIcon>*/}
            My Account
          </MenuItem>
          <MenuItem onClick={handleBilling}>
            {/*<ListItemIcon>
              <CreditCardIcon sx={{ color: '#2c3e50' }} />
            </ListItemIcon>*/}
            Subscriptions
          </MenuItem>
          <Divider sx={{ my: 1 }} />
          <MenuItem onClick={handleSignOut}>
            <ListItemIcon>
              <LogoutIcon sx={{ color: '#2c3e50' }} />
            </ListItemIcon>
            Sign Out
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardHeader;